import { render, staticRenderFns } from "./Casedetail.vue?vue&type=template&id=1bad21e1&scoped=true&"
import script from "./Casedetail.vue?vue&type=script&lang=js&"
export * from "./Casedetail.vue?vue&type=script&lang=js&"
import style0 from "./Casedetail.vue?vue&type=style&index=0&id=1bad21e1&prod&lang=less&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1bad21e1",
  null
  
)

export default component.exports